import { AutomobileComplaint } from '@/reports/types/vehicles';
import { Accordion, Stack, Table, Text } from '@/theme/index';
import { formatDateFromReport } from '@/utils/formatDateFromReport/formatDateFromReport';

type VehicleSafetyComplaintCardProps = {
  complaint: AutomobileComplaint;
};

export const VehicleSafetyComplaintCard = ({
  complaint,
}: VehicleSafetyComplaintCardProps) => {
  const title = (
    <Stack>
      {complaint.date_complaint_filed?.date && (
        <Text data-testid="complaint-card-filed-date">
          {formatDateFromReport(
            complaint.date_complaint_filed.date,
            'MM/dd/yyyy'
          )}
        </Text>
      )}
      <Text variant="h4">{complaint.component}</Text>
    </Stack>
  );

  const tableData = [
    ['Date of incident', complaint.date_of_incident?.date],
    ['Date filed', complaint.date_complaint_filed?.date],
    ['Crash', complaint.crash],
    ['Fire', complaint.fire],
    ['Injured', complaint.number_of_injured],
    ['Deaths', complaint.number_of_deaths],
  ]
    .filter((row) => Boolean(row[1]))
    .map((row) => {
      return row.map((element) => `${element}`);
    });

  return (
    <Accordion display={title}>
      <Table
        sectionId="complaint-card"
        rows={tableData}
        className="striped flipped"
      />
      {complaint.summary && (
        <Stack spacing={2} mt={2}>
          <Text>Summary of complaint</Text>
          <Text>{complaint.summary}</Text>
        </Stack>
      )}
    </Accordion>
  );
};
